import React, { useState, useEffect, useRef } from "react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { AgGridReact } from "ag-grid-react";
import moment from "moment/moment";
import "../pagination/pagination.css";
import Pagination from "../pagination/pagination";
import Select from "react-select";
import { RiRefreshLine } from "react-icons/ri";
import { FaFileCircleExclamation } from "react-icons/fa6";
import LeaseApiService from "../../services/apiService";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { ClipLoader } from 'react-spinners';
import { toast } from "react-toastify";
import { AsyncPaginate } from 'react-select-async-paginate';
import * as XLSX from "xlsx-js-style";

const UnitMasterListReport = () => {
    const apiService = new LeaseApiService();
    const ITEMS_PER_PAGE = 100
    const gridRef = useRef();
    const [rowData, setRowData] = useState([]);
    const [exportData, setExportData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pageSize, setPageSize] = useState(50);
    const [pagination, setPagination] = useState();
    const [FilterTab, setFilterTab] = useState(true);
    const [propertyList, setPropertyList] = useState([]);
    const [unitList, setUnitList] = useState([]);
    const [leaseList, setLeaseList] = useState([]);
    const [tanentList, setTanentList] = useState([]);
    const [loader, setLoader] = useState(false);
    const [formData, setFormData] = useState({
        property: { label: "All", value: "All" },
        unitNo: "",
        leaseNo: "",
        tenant: "",
        asOfDate: "",
    })
    const formatDate = (date) => {
        return moment(date).format("DD-MMM-YYYY");
    };
    useEffect(() => {
        fetchDropdownData();

        const today = new Date();
        const toDate = new Date(today.getFullYear(), 11, 31);

        setFormData((prev) => ({
            ...prev,
            asOfDate: formatDate(toDate),
        }));
    }, []);

    const fetchDropdownData = async () => {
        try {
            const params = new URLSearchParams();
            params.append('dropdownTypes', 'LRAgreeSearchProperties,LRSearchLeaseNos,LRAgreeSearchCustomers,');
            const res = await apiService.getApiParamater('REPORT_MULTI_DROP', `?${params.toString()}`);
            const addAllOption = (list) => [{ value: 'All', text: 'All' }, ...list || []];
            setPropertyList(res?.data?.dropdowns?.LRAgreeSearchProperties);
            setLeaseList(addAllOption(res?.data?.dropdowns?.LeaseNo));
            setTanentList(res?.data?.dropdowns?.LRAgreeSearchCustomers || []);
        } catch (error) {
            console.error('Error fetching dropdown data:', error);
        }
    }
    const getItems = async (newPageNo = pagination?.currentPage) => {
        try {
            setLoader(true)
            const params = new URLSearchParams();
            params.append("PageNo", newPageNo || 1);
            params.append("PageSize", pageSize || 50);
            params.append("unitMasterListReportRequest.PropertyNo", formData?.property?.value?.value || "All");
            params.append("unitMasterListReportRequest.UnitNo", formData?.unitNo?.label || "All");
            params.append("unitMasterListReportRequest.CustomerNo", formData?.tenant?.value?.value || "All");
            params.append("unitMasterListReportRequest.Status", "All");
            params.append("unitMasterListReportRequest.LeaseNo", formData?.leaseNo?.label || "All");
            params.append("unitMasterListReportRequest.LeaseStart", "");
            params.append("unitMasterListReportRequest.LeaseEnd", formData?.asOfDate || "");
            const res = await apiService.getApiParamater("REPORT_UNIT_MASTER_LIST", `?${params.toString()}`);
            if (res?.data?.result) {
                setRowData(res?.data?.result || []);
                setPagination(res.data.paginationData);
                getAllItems(res.data.paginationData)
                setLoading(false);
                setLoader(false)
            } else {
                setRowData(res?.data?.result || []);
                toast.error(res?.data?.message)
                setLoader(false)
                setLoading(false);
            }
        } catch (error) {
            console.error("Error fetching items:", error);
            setLoader(false)
            setLoading(false);
        }
    }
    const getAllItems = async (total) => {
        try {
            setLoader(true)
            const params = new URLSearchParams();
            params.append("PageNo", 1);
            params.append("PageSize", total?.totalRecords);
            params.append("unitMasterListReportRequest.PropertyNo", formData?.property?.value?.value || "All");
            params.append("unitMasterListReportRequest.UnitNo", formData?.unitNo?.label || "All");
            params.append("unitMasterListReportRequest.CustomerNo", formData?.tenant?.value?.value || "All");
            params.append("unitMasterListReportRequest.Status", "All");
            params.append("unitMasterListReportRequest.LeaseNo", formData?.leaseNo?.label || "All");
            params.append("unitMasterListReportRequest.LeaseStart", "");
            params.append("unitMasterListReportRequest.LeaseEnd", formData?.asOfDate || "");
            const res = await apiService.getApiParamater("REPORT_UNIT_MASTER_LIST", `?${params.toString()}`);
            if (res?.data?.result) {
                setExportData(res?.data?.result || []);
                setLoading(false);
                setLoader(false)
            } else {
                setLoader(false)
                setLoading(false);
            }
        } catch (error) {
            console.error("Error fetching items:", error);
            setLoading(false);
        }
    }
    const columnDefs = [
        { headerName: "Property No", field: "propertyNo", filter: true, floatingFilter: true, suppressMovable: true, width: 130, pinned: "left" },
        { headerName: "Property Name", field: "propertyName", filter: true, floatingFilter: true, suppressMovable: true, width: 200, pinned: "left" },
        { headerName: "Unit No", field: "unitNo", filter: true, floatingFilter: true, suppressMovable: true, width: 100 },
        { headerName: "Unit Type", field: "unitType", filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
        { headerName: "Unit Category", field: "unitCategory", filter: true, floatingFilter: true, suppressMovable: true, width: 130 },
        { headerName: "Floor", field: "floor", filter: true, floatingFilter: true, suppressMovable: true, width: 100 },
        { headerName: "Total Area", field: "total_Area", filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
        { headerName: "Status", field: "leaseStatus", filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
        { headerName: "Lease No", field: "lease_No", filter: true, floatingFilter: true, suppressMovable: true, width: 130 },
        { headerName: "Lease Start Date", field: "leaseStartDate", filter: true, floatingFilter: true, suppressMovable: true, width: 140 },
        { headerName: "Lease Expiry Date", field: "leaseExpiryDate", filter: true, floatingFilter: true, suppressMovable: true, width: 140 },
        { headerName: "Tenant No", field: "tenantNo", filter: true, floatingFilter: true, suppressMovable: true, width: 130 },
        { headerName: "Tenant Name", field: "tenantName", filter: true, floatingFilter: true, suppressMovable: true, width: 200 },
        { headerName: "Tenant Type", field: "tenantType", filter: true, floatingFilter: true, suppressMovable: true, width: 130 },
        { headerName: "Rent Per Month", field: "rentPerMonth", filter: true, floatingFilter: true, suppressMovable: true, width: 140 },
        { headerName: "Rent Per Annum", field: "rentPerAnnum", filter: true, floatingFilter: true, suppressMovable: true, width: 140 },
        { headerName: "No Of Installments", field: "noOfInstallments", filter: true, floatingFilter: true, suppressMovable: true, width: 150 },
    ]
    const handleClearFilters = () => {
        setUnitList([])
        setRowData([])
        const today = new Date();
        const toDate = new Date(today.getFullYear(), 11, 31);
        setFormData({
            property: { label: "All", value: "All" },
            unitNo: "",
            leaseNo: "",
            tenant: "",
            asOfDate: formatDate(toDate),
        });
    }
    const handleDropDownChange = async ({ name, value }) => {
        if (name === "property") {
            setFormData(prev => ({ ...prev, unitNo: null }));
            const propertyValue = value?.value === 'All' ? null : value?.value;
            const params = new URLSearchParams();
            params.append('DropdownFor', 'LRAgreehUnitNosByPropertyId');
            params.append('CascadValue', propertyValue?.value);
            const res = await apiService.getApiParamater('REPORT_CASCAD', `?${params.toString()}`);
            setUnitList(res?.data?.items || []);
            setFormData(prev => ({ ...prev, [name]: value }));
        } else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }
    }
    const handleDateChange = async (input) => {
        const name = input?.target?.name || input.name;
        const value = input?.target?.value || input.value;

        const updatedValue = typeof value === 'string' ? value : formatDate(value);
        let updatedDates = { ...formData, [name]: updatedValue };
        setFormData(updatedDates);
    }
    const loadTenantOptions = (search, loadedOptions, { page }) => {
        let filtered = tanentList;

        if (search) {
            filtered = tanentList.filter(tenant =>
                tenant.value.toLowerCase().includes(search.toLowerCase()) ||
                tenant.text.toLowerCase().includes(search.toLowerCase())
            );
        }

        const start = page * ITEMS_PER_PAGE;
        const end = start + ITEMS_PER_PAGE;

        const optionsChunk = filtered.slice(start, end);

        return Promise.resolve({
            options: optionsChunk.map(tenant => ({ value: tenant, label: tenant.text })),
            hasMore: end < filtered.length,
            additional: { page: page + 1 }
        });
    }
    const normalizeValue = (value) => {
        if (value === null || value === undefined) return "";
        if (value === 0 || value === "0") return "";

        if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(value)) {
            return moment(value).format("DD-MMM-YYYY");
        }

        return value;
    };
    const exportColumns = [
        { header: "Property No", dataKey: "propertyNo" },
        { header: "Property Name", dataKey: "propertyName" },
        { header: "Unit No", dataKey: "unitNo" },
        { header: "Unit Type", dataKey: "unitType" },
        { header: "Unit Category", dataKey: "unitCategory" },
        { header: "Floor", dataKey: "floor" },
        { header: "Total Area", dataKey: "total_Area" },
        { header: "Status", dataKey: "leaseStatus" },
        { header: "Lease No", dataKey: "lease_No" },
        { header: "Lease Start Date", dataKey: "leaseStartDate" },
        { header: "Lease Expiry Date", dataKey: "leaseExpiryDate" },
        { header: "Tenant Name", dataKey: "tenantName" },
        { header: "Rent Per Month", dataKey: "rentPerMonth" },
        { header: "Rent Per Annum", dataKey: "rentPerAnnum" },
        { header: "No Of Installments", dataKey: "noOfInstallments" },
    ];
    const exportPDF = () => {
        if (!exportData?.length) return;

        const doc = new jsPDF("landscape", "pt", "A4");

        doc.setFillColor(110, 81, 153);
        doc.rect(0, 0, doc.internal.pageSize.width, 50, "F");

        doc.setTextColor(255);
        doc.setFontSize(16);
        doc.text("Unit Master List Report", 40, 32);

        doc.setFontSize(9);
        doc.text(
            `Generated on: ${moment().format("DD-MMM-YYYY")}`,
            doc.internal.pageSize.width - 160,
            32
        );

        doc.setTextColor(0);

        doc.autoTable({
            startY: 60,
            head: [exportColumns.map(col => col.header)],
            body: exportData.map(row =>
                exportColumns.map(col => normalizeValue(row[col.dataKey]))
            ),
            styles: {
                fontSize: 8,
                cellPadding: 5,
                valign: "middle",
            },
            headStyles: {
                fillColor: [110, 81, 153],
                textColor: 255,
                fontStyle: "bold",
                halign: "center",
            },
            bodyStyles: {
                halign: "center",
            },
            alternateRowStyles: {
                fillColor: [240, 237, 245],
            },
            didDrawPage: data => {
                doc.setFontSize(8);
                doc.text(
                    `Page ${data.pageNumber}`,
                    doc.internal.pageSize.width / 2,
                    doc.internal.pageSize.height - 10,
                    { align: "center" }
                );
            },
        });
        doc.save("Unit Master List Report.pdf");
    };
    const exportExcel = () => {
        if (!exportData?.length) return;

        const title = "UNIT MASTER LIST REPORT";

        // Reuse the grid's own column definitions (header + formatter) so the
        // export can never drift out of sync with what the grid shows.
        const columns = columnDefs.map(col => ({
            header: col.headerName,
            field: col.field,
            valueFormatter: col.valueFormatter,
        }));

        const dataRows = exportData.map(item =>
            columns.map(col =>
                col.valueFormatter
                    ? col.valueFormatter({ value: item[col.field], data: item })
                    : normalizeValue(item[col.field])
            )
        );

        const worksheet = XLSX.utils.aoa_to_sheet([
            [title],
            columns.map(c => c.header),
            ...dataRows,
        ]);

        // Merge Title
        worksheet["!merges"] = [
            { s: { r: 0, c: 0 }, e: { r: 0, c: columns.length - 1 } },
        ];

        // Auto column width
        worksheet["!cols"] = columns.map((col, i) => {
            const maxLength = Math.max(
                col.header.length,
                ...dataRows.map(r => String(r[i] ?? "").length)
            );
            return { wch: maxLength + 4 };
        });

        // Freeze header
        worksheet["!freeze"] = { ySplit: 2 };

        // Border style with color
        const borderStyle = {
            top: { style: "thin", color: { rgb: "FF000000" } },
            bottom: { style: "thin", color: { rgb: "FF000000" } },
            left: { style: "thin", color: { rgb: "FF000000" } },
            right: { style: "thin", color: { rgb: "FF000000" } },
        };

        // Title style
        const titleCell = worksheet["A1"];
        if (titleCell) {
            titleCell.s = {
                font: { bold: true, sz: 16, color: { rgb: "FF333333" } },
                alignment: { horizontal: "left", vertical: "center" },
                border: borderStyle,
            };
        }

        // Header style
        columns.forEach((_, c) => {
            const cell = worksheet[XLSX.utils.encode_cell({ r: 1, c })];
            if (!cell) return;

            cell.s = {
                font: { bold: true, sz: 11, color: { rgb: "FFFFFFFF" } },
                fill: { fgColor: { rgb: "FF6E5199" } },
                alignment: { horizontal: "center", vertical: "center" },
                border: borderStyle,
            };
        });

        // Data cells
        dataRows.forEach((row, r) => {
            columns.forEach((col, c) => {
                const cell = worksheet[XLSX.utils.encode_cell({ r: r + 2, c })];
                if (!cell) return;

                cell.s = {
                    font: { sz: 10, color: { rgb: "FF000000" } },
                    alignment: { vertical: "center", horizontal: "left" },
                    border: borderStyle,
                };
            });
        });

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Unit Master List");
        XLSX.writeFile(workbook, "Unit_Master_List_Report.xlsx");
    };
    return (
        <div className="p-3">
            <div className="cost-center-section">
                <div
                    className="d-flex mt-3 cursor-pointer slide-header"
                    onClick={() => setFilterTab(!FilterTab)}
                >
                    <div className="h6 pt-1">Search Parameters</div>
                </div>
                <div className={`slide-content ${FilterTab ? "open" : "closed"}`}>
                    <div className={`border-box2 p-3 ${FilterTab ? "slide-in" : "slide-out"}`}>
                        <div className="form-group grid-contain ">
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Property </label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    isClearable
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.property}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'property', value: selectedOption })}
                                    options={propertyList?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Unit No </label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    isClearable
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.unitNo}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'unitNo', value: selectedOption })}
                                    options={unitList?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Lease No</label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    isClearable
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.leaseNo}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'leaseNo', value: selectedOption })}
                                    options={leaseList?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Tenant</label>
                                <AsyncPaginate
                                    className="p-0 w-100"
                                    menuPortalTarget={document.body}
                                    isClearable
                                    styles={{
                                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                                        control: base => ({ ...base, fontSize: "12px" }),
                                        singleValue: base => ({ ...base, fontSize: "12px" }),
                                        input: base => ({ ...base, fontSize: "12px" }),
                                        placeholder: base => ({ ...base, fontSize: "12px" }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            fontSize: "12px",
                                            backgroundColor: state.isFocused ? "#F5F5F5" : null,
                                            color: "#000",
                                            ":hover": { backgroundColor: "#F5F5F5", color: "#000" }
                                        }),
                                    }}
                                    value={formData?.tenant}
                                    loadOptions={loadTenantOptions}
                                    onChange={(selectedOption) => handleDropDownChange({ name: "tenant", value: selectedOption })}
                                    additional={{ page: 0 }}
                                />
                            </div>
                            <div className="d-flex">
                                <label className="form-label w-0"> As of Date</label>
                                <DatePicker
                                    selected={formData.asOfDate}
                                    onChange={(date) => handleDateChange({ name: 'asOfDate', value: date })}
                                    dateFormat="dd-MMM-yyyy"
                                    className="p-2 form-control w-100 datepicker-icon"
                                />
                            </div>
                        </div>
                        <div className="d-flex flex-wrap justify-content-end align-items-end mt-3" style={{ maxWidth: '1200px', margin: 'auto', gap: '20px' }}>
                            <div className="d-flex gap-1">
                                {loader === true ?
                                    <div className='mainbtnGry flex-end gap-2 w-50'>
                                        <ClipLoader color="#ffffff" className='mt-1' size={25} />
                                    </div>
                                    :
                                    <div
                                        onClick={() => getItems()}
                                        className="mainbtnGry flex-end gap-2 w-50"
                                    >
                                        <FaFileCircleExclamation
                                            color="#fff"
                                            className="center mt-2 mx-2"
                                        />
                                        <div className="center">Search</div>
                                    </div>
                                }
                                <div
                                    onClick={() => handleClearFilters()}
                                    className="mainbtnRed flex-end gap-2 w-50"
                                >
                                    <RiRefreshLine color="#fff" className="center mt-2 mx-2" />
                                    <div className="center">Reset</div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div className="border-box2 p-3">
                {loading ? (
                    <div>Loading...</div>
                ) : (
                    <>
                        <div className="d-flex justify-content-between">
                            <h5 className="col mainInvHead">Unit Master List Report</h5>
                            <button className="btn btn-primary" onClick={exportPDF}>
                                Export as PDF
                            </button>
                            <button className="btn btn-secondary mx-3" onClick={exportExcel}>
                                Export as Excel
                            </button>
                        </div>

                        <div className="gridshad mt-3">
                            <div className="ag-theme-quartz" style={{ height: 650 }}>
                                <AgGridReact
                                    ref={gridRef}
                                    getRowStyle={(params) => (params.node.rowIndex % 2 === 0 ? { background: "#F0EDF5" } : { background: "#fff" })}
                                    rowData={rowData}
                                    enableFilter={true}
                                    floatingFilter={true}
                                    columnDefs={columnDefs}
                                />
                            </div>
                            <Pagination
                                pageSize={pageSize}
                                setPageSize={setPageSize}
                                pagination={pagination}
                                getItems={getItems}
                            />
                        </div>
                    </>
                )}
            </div>
        </div >
    );
};
export default UnitMasterListReport;
